import React from 'react';
import { useApolloClient } from '@apollo/client';
import { noop } from 'lodash';

import useTranslation from 'hooks/use-translation';
import useUser from 'hooks/use-user';
import useErnie from 'shared/hooks/use-ernie';

import { useModals, ModalNames } from 'components/modals';

import MyAccountPopover from './my-account-popover';

const MyAccountPopoverWrapper = ({ isLoggedIn, anchorEL }) => {
  const { t } = useTranslation();
  const User = useUser();
  const { openModal } = useModals();
  const ernie = useErnie();
  const apolloClient = useApolloClient();

  const handleOptionClick = (value) => {
    openModal(value === 'login' ? ModalNames.login : ModalNames.signUp);
  };

  const handleOnLogout = async () => {
    // Logout is synchronous but we structure this carefully to ensure
    // auth state is cleared before Apollo refetches
    User.logout();

    /**
     * Clear Apollo cache on logout. Use clearStore() instead of resetStore() to avoid
     * refetching ALL active queries at once, which can hang the browser.
     *
     * Queries will refetch lazily as components need data. Exclusive content updates
     * correctly because userSegmentIds in query variables changes on logout.
     */
    // Cache clear may fail, but logout should still proceed
    await apolloClient.clearStore().catch(noop);

    ernie(t('ernie.logout', "You've been successfully logged out."), 'success');
  };

  return (
    <MyAccountPopover
      isLoggedIn={isLoggedIn}
      onOptionClick={handleOptionClick}
      onLogout={handleOnLogout}
      anchorEL={anchorEL}
    />
  );
};

export default MyAccountPopoverWrapper;
